import React, {Component} from "react";
import styled from "styled-components";
import VerticalAlignTopIcon from "@material-ui/icons/VerticalAlignTop";
class ScrollToTopButton extends Component {
    state = {
        isShow: false,
    };
    componentDidMount() {
        const { handleScroll } = this;
        handleScroll();
        window.addEventListener("scroll", handleScroll);
    }
    componentWillUnmount() {
        const { handleScroll } = this;
        window.removeEventListener("scroll", handleScroll);
    }
    handleScroll = () => {
        let isShow = window.pageYOffset >= 280;
        this.setState({ isShow });
    };
    render() {
        const { state:{isShow}, props: {text} } = this
        return (
            <Button 
                isShow={isShow}
                onClick={() => window.scrollTo({ 
                    top: 0,
                    behavior: "smooth" 
                })}
            >
                {text}
                <IconWrap>
                    <VerticalAlignTopIcon color="inherit" fontSize="inherit"/>
                </IconWrap>
            </Button>
        )
    }
}
export default ScrollToTopButton
const Button = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    display: ${({isShow}) => isShow ? "flex": "none"};
    opacity: ${({isShow}) => isShow ? "1": "0"};
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 70px;
    padding: 10px;
    z-index: 10000;
    box-shadow: 0 1px 6px 0 rgba(32,33,36,0.28);
    box-sizing: border-box;
    background-color: #fff;
    color: #979797;
    transition: all .2s ease-in-out;
`
const IconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    width: 16px;
    margin-left: 5px;
    color: #979797;
    font-size: 16px;
    /* border-radius: 100%; */
    /* background-color: #979797; */
    /* transform: rotate(-90deg); */
`


// WEBPACK FOOTER //
// ./src/Ranking/RankCondition/ScorllToTopButton.js